import axios from "axios";

export const state = {
    stores: [],
};

export const getters = {
    stores: state => state.stores,
};

export const mutations = {
    setStores(state, newValue) {
        state.stores = newValue
    },
};

export const actions = {
    fetchStores({ commit }) {
        axios.get('/stores').then(res => {
            commit('setStores', res.data.stores)
        })
    },
};
